import React from "react";
import "./Notfound.css";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { useNavigate } from "react-router";
import { Button, Box } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";

const NotFound = ({ message }) => {
  useDocumentTitle("Page Not Found");
  const navigate = useNavigate();

  return (
    <section className="page_404">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 ">
            <div className="col-sm-12 col-sm-offset-1  text-center">
              <div className="four_zero_four_bg">
                <h1 className="text-center ">404</h1>
              </div>

              <div className="contant_box_404">
                <h3 className="h2">Oops! Page Not Found</h3>

                <p className="not-found-message">
                  {message ||
                    "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable."}
                </p>

                <Box sx={{ mt: 3, display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<HomeIcon />}
                    onClick={() => navigate("/")}
                    className="link_404"
                  >
                    Go to Home
                  </Button>
                  
                  <Button
                    variant="outlined"
                    color="primary"
                    size="large"
                    onClick={() => navigate(-1)}
                  >
                    Go Back
                  </Button>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
